import React from 'react';
import { SkipLinksProps } from './SkipLinks.types';
import './SkipLinks.scss';

const SkipLinks = ({
  skipToContentLink = '#main-content',
  skipToNavLink,
  skipToFooterLink,
}: SkipLinksProps) => {
  return (
    <>
      <a
        href={skipToContentLink}
        className="skip-to-link"
        id="content-skip-link"
      >
        Skip to content
      </a>
      {skipToNavLink ? (
        <a href={skipToNavLink} className="skip-to-link" id="nav-skip-link">
          Skip to navigation
        </a>
      ) : null}
      {skipToFooterLink ? (
        <a
          href={skipToFooterLink}
          className="skip-to-link"
          id="footer-skip-link"
        >
          Skip to footer
        </a>
      ) : null}
    </>
  );
};

export default SkipLinks;
